import { useMemo } from "react";
import api, { useSWR } from "../utils/axios";
import { getDataSourceStore } from "../utils/devextreme-grid";

import { HOST_API } from "../config-global";

const baseUrl = `/api/category/`;

export function getgrid() {
  return getDataSourceStore(`${HOST_API}${baseUrl}get-grid`);
}

export function create(request) {
  return api.post(`${baseUrl}`, {
    ...request,
  });
}

export function update(id, request) {
  return api.put(`${baseUrl}update/${id}`, {
    ...request,
  });
}

export function remove(id) {
  return api.delete(`${baseUrl}${id}`);
}

export function getList(search) {
  return api.post(`${baseUrl}get-list`, {
    search,
  });
}

export function useGetPlainTree(
  shouldFetch = true,
  onlyContainer = false,
  disableContainer = false
) {
  const url = `${baseUrl}plain-tree/${onlyContainer}/${disableContainer}`;

  const { data, isLoading, error, isValidating, mutate } = useSWR(shouldFetch ? url : null);

  const memoizedValue = useMemo(
    () => ({
      tree: data || [],
      isLoading,
      error,
      isValidating,
      mutate,
    }),
    [data, error, isLoading, isValidating, mutate]
  );

  return memoizedValue;
}

export function getDefaultCategory() {
  return api.get(`${baseUrl}category-default`);
}

export function useGetDefaultCategory() {
  const url = `${baseUrl}category-default`;

  const { data, isLoading, error, isValidating, mutate } = useSWR(url);

  const memoizedValue = useMemo(
    () => ({
      categoryDefault: data,
      isLoading,
      error,
      isValidating,
      mutate,
    }),
    [data, error, isLoading, isValidating, mutate]
  );

  return memoizedValue;
}

export function useGetCategory(id, undelete = false) {
  const url = `${baseUrl}${undelete ? "get-undelete/" : ""}${id}`;

  const { data, isLoading, error, isValidating, mutate } = useSWR(id ? url : null);

  const memoizedValue = useMemo(
    () => ({
      category: data ? { ...data } : null,
      isLoading,
      error,
      isValidating,
      mutate,
    }),
    [data, error, isLoading, isValidating, mutate]
  );

  return memoizedValue;
}

export function useGetCategoryName(id) {
  const url = `${baseUrl}get-name/${id}`;

  const { data, isLoading, error, isValidating, mutate } = useSWR(id ? url : null);

  const memoizedValue = useMemo(
    () => ({
      category: data ? { ...data } : null,
      isLoading,
      error,
      isValidating,
      mutate,
    }),
    [data, error, isLoading, isValidating, mutate]
  );

  return memoizedValue;
}
